import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-venaqi-service-two',
  templateUrl: './venaqi-service-two.component.html',
  styleUrls: ['./venaqi-service-two.component.scss']
})
export class VenaqiServiceTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
